module.exports = __webpack_public_path__ + "static/media/home-img-1.15104615.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/home-img-1.svg
// module id = 666
// module chunks = 0